import PrinterList from "./PrinterList";
import "./printManager.css";

export default function PrintManagerPage() {
  return (
    <div className="pm-page">
      <h2>Print Manager</h2>
      <PrinterList />
    </div>
  );
}
